`use strict`;

import Xhr from './xhr';

export default class PopulateDropdowns
{
    constructor() {
        this.localCountryId = 1;
        this.selectedCountryId = 0;
    }

    populateRegions (countryID = 0, selector = undefined) {
        this.selectedCountryId = countryID;
        let dropdown = selector || $(window.selectors.selectRegion);
        dropdown.empty();
        dropdown.append($('<option>', {
            value: '',
            text: 'Alege Județul'
        }));
        dropdown.change();
        if(this.selectedCountryId > 0) {
            return new Promise((resolve, reject) => {
                let options = {
                    url: window.Laravel.showRegions,
    
                    data: {
                        countryID: this.selectedCountryId
                    },
    
                    success: (data) => {
                        $.each(data.message, (index, value) => {
                            dropdown.append($('<option>', {
                                value: value,
                                text: index
                            }));
                        });
                        if (this.selectedCountryId != this.localCountryId) {
                            dropdown.find('option:last').prop('selected', true);
                        }
                        dropdown.change();
                    },
    
                    error: (xhr) => {
                        reject(xhr.responseJson);
                    }
                };
    
                let xhr = new Xhr();
                xhr.setOptions(options);
                xhr.execute();
            });
        }
    }

    populateCities (regionID = 0, selector = undefined) {
        let dropdown = selector || $(window.selectors.selectCity);
        dropdown.empty();
        dropdown.append($('<option>', {
            value: '',
            text: 'Alege Localitatea'
        }));
        dropdown.change();
        if(regionID > 0) {
            return new Promise((resolve, reject) => {
                let options = {
                    url: window.Laravel.showCities,
    
                    data: {
                        regionID: regionID
                    },
    
                    success: (data) => {
                        $.each(data.message, (index, value) => {
                            dropdown.append($('<option>', {
                                value: value,
                                text: index
                            }));
                        });
                        if (this.selectedCountryId != this.localCountryId) {
                            dropdown.find('option:last').prop('selected', true);
                        }
                        dropdown.change();
                    },
    
                    error: (xhr) => {
                        reject(xhr.responseJson);
                    }
                };
    
                let xhr = new Xhr();
                xhr.setOptions(options);
                xhr.execute();
            });
        }
    }
}